// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/images/BG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/images/btn.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro_leftContent__D2-4h {
  grid-gap: 16px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.intro_leftContent__D2-4h h2 {
  font-weight: 700;
  font-family: Inter;
  font-size: 60px;
  line-height: 72px;
  max-width: 648px;
  width: 100%;
  letter-spacing: -1px;
  color: #111827;
}
.intro_leftContent__D2-4h p {
  max-width: 648px;
  width: 100%;
  color: #374151;
  font-family: Inter;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
}

.intro_relativeContainer__5WsLV {
  position: relative;
}
.intro_relativeContainer__5WsLV .intro_rightLines__3xTSA {
  position: absolute;
  z-index: -1;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.intro_relativeContainer__5WsLV .intro_rightLines__3xTSA .intro_lineCont__0HR4Y {
  position: relative;
  top: -100px;
}
.intro_relativeContainer__5WsLV .intro_rightLines__3xTSA .intro_lineCont__0HR4Y .intro_green__AUCjL {
  position: absolute;
  right: 0;
  bottom: 73px;
}
.intro_relativeContainer__5WsLV .intro_rightLines__3xTSA .intro_lineCont__0HR4Y .intro_purple__-CuT7 {
  position: absolute;
  bottom: 83px;
  right: 0;
}
.intro_relativeContainer__5WsLV .intro_leftLines__FNDDm {
  z-index: -1;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.intro_relativeContainer__5WsLV .intro_leftLines__FNDDm .intro_lineCont__0HR4Y {
  position: relative;
  top: 40px;
}
.intro_relativeContainer__5WsLV .intro_leftLines__FNDDm .intro_lineCont__0HR4Y .intro_green__AUCjL {
  position: absolute;
  bottom: 0;
  left: 0;
}
.intro_relativeContainer__5WsLV .intro_leftLines__FNDDm .intro_lineCont__0HR4Y .intro_purple__-CuT7 {
  bottom: 83px;
  position: absolute;
  left: 0;
}

.intro_body__CxNEZ::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100vh;
  transform: translate(-50%, 0);
  z-index: -2;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
  background-size: cover;
}

.intro_wrapper__-ZGpL {
  margin-top: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.intro_watchVideo__i9eCv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) left no-repeat;
  padding-left: 28px;
  color: #7C3AED;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
}

.intro_actions__bTngE {
  display: flex;
  align-items: center;
  grid-gap: 28px;
}

.intro_getStarted__k\\+LVr {
  border-radius: 8px;
  background: #7C3AED;
  color: #fff;
  padding: 16px 24px;
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
}

@media (max-width: 1366px) {
  .intro_rightLines__3xTSA .intro_lineCont__0HR4Y {
    top: -53px !important;
  }
}
@media (max-width: 1280px) {
  .intro_rightLines__3xTSA .intro_lineCont__0HR4Y {
    top: -40px !important;
  }
}
@media (max-width: 1450px) {
  .intro_rightLines__3xTSA .intro_lineCont__0HR4Y {
    top: -65px;
  }
}
@media (max-width: 1024px) {
  .intro_leftContent__D2-4h h2 {
    font-size: 52px;
    line-height: 65px;
  }
}
@media (max-width: 1024px) {
  .intro_mobileBody__s-nIJ {
    display: none;
  }
}
@media (max-width: 430px) {
  .intro_wrapper__-ZGpL {
    margin-top: 80px;
  }
  .intro_leftContent__D2-4h h2 {
    font-size: 48px;
    line-height: 58px;
  }
  .intro_leftContent__D2-4h p {
    font-size: 16px;
  }
  .intro_leftLines__FNDDm .intro_lineCont__0HR4Y {
    top: 113px !important;
  }
  .intro_rightLines__3xTSA {
    display: none !important;
  }
  .intro_mobileBody__s-nIJ {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/intro/intro.module.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AADF;AAGE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AADJ;AAIE;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAHJ;AAII;EACE,kBAAA;EACA,WAAA;AAFN;AAGM;EACE,kBAAA;EACA,QAAA;EACA,YAAA;AADR;AAIM;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AAFR;AAQE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AANJ;AAQI;EACE,kBAAA;EACA,SAAA;AANN;AAQM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AANR;AASM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;AAPR;;AAeE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,oEAAA;EACA,sBAAA;AAZJ;;AAgBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,kEAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAbF;;AAgBA;EAEI;IACE,qBAAA;EAdJ;AACF;AAyBA;EAEI;IACE,qBAAA;EAxBJ;AACF;AAmCA;EAEI;IACE,UAAA;EAlCJ;AACF;AA6CA;EAEI;IACE,eAAA;IACA,iBAAA;EA5CJ;AACF;AAgDA;EACE;IACE,aAAA;EA9CF;AACF;AAiDA;EACE;IACE,gBAAA;EA/CF;EAuDE;IACE,eAAA;IACA,iBAAA;EArDJ;EAuDE;IACE,eAAA;EArDJ;EAyDE;IACE,qBAAA;EAvDJ;EA0DA;IACE,wBAAA;EAxDF;EA0DA;IACE,aAAA;EAxDF;AACF","sourcesContent":["\r\n\r\n.leftContent {\r\n  grid-gap: 16px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n\r\n  h2 {\r\n    font-weight: 700;\r\n    font-family: Inter;\r\n    font-size: 60px;\r\n    line-height: 72px;\r\n    max-width: 648px;\r\n    width: 100%;\r\n    letter-spacing: -1px;\r\n    color: #111827;\r\n  }\r\n\r\n  p {\r\n    max-width: 648px;\r\n    width: 100%;\r\n    color: #374151;\r\n    font-family: Inter;\r\n    font-weight: 400;\r\n    font-size: 18px;\r\n    line-height: 28px;\r\n  }\r\n}\r\n\r\n.relativeContainer {\r\n  position: relative;\r\n\r\n  .rightLines {\r\n    position: absolute;\r\n    z-index: -1;\r\n    bottom: 0;\r\n    right: 0;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    .lineCont {\r\n      position: relative;\r\n      top: -100px;\r\n      .green {\r\n        position: absolute;\r\n        right: 0;\r\n        bottom: 73px;\r\n      }\r\n\r\n      .purple {\r\n        position: absolute;\r\n        bottom: 83px;\r\n        right: 0;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  .leftLines {\r\n    z-index: -1;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n\r\n    .lineCont {\r\n      position: relative;\r\n      top: 40px;\r\n\r\n      .green {\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n      }\r\n\r\n      .purple {\r\n        bottom: 83px;\r\n        position: absolute;\r\n        left: 0;\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.body {\r\n  &::after {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    width: 100%;\r\n    height: 100vh;\r\n    transform: translate(-50%,0);\r\n    z-index: -2;\r\n    background: url(\"../../shared/images/BG.png\") center no-repeat;\r\n    background-size: cover;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  margin-top: 110px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.watchVideo {\r\n  background: url(\"../../shared/images/btn.svg\") left no-repeat;\r\n  padding-left: 28px;\r\n  color: #7C3AED;\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 28px;\r\n}\r\n\r\n.getStarted {\r\n  border-radius: 8px;\r\n  background: #7C3AED;\r\n  color: #fff;\r\n  padding: 16px 24px;\r\n  font-family: Inter;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n@media (max-width: 1366px) {\r\n  .rightLines {\r\n    .lineCont {\r\n      top: -53px !important;\r\n      .green {\r\n\r\n      }\r\n      .purple {\r\n\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n  .rightLines {\r\n    .lineCont {\r\n      top: -40px !important;\r\n      .green {\r\n\r\n      }\r\n      .purple {\r\n\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media (max-width: 1450px) {\r\n  .rightLines {\r\n    .lineCont {\r\n      top: -65px;\r\n      .green {\r\n\r\n      }\r\n      .purple {\r\n\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .leftContent {\r\n    h2 {\r\n      font-size: 52px;\r\n      line-height: 65px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .mobileBody {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 430px) {\r\n  .wrapper {\r\n    margin-top: 80px;\r\n  }\r\n  .actions {\r\n\r\n    .watchVideo {\r\n    }\r\n  }\r\n  .leftContent {\r\n    h2 {\r\n      font-size: 48px;\r\n      line-height: 58px;\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n  .leftLines {\r\n    .lineCont {\r\n      top: 113px !important;\r\n    }\r\n  }\r\n  .rightLines {\r\n    display: none !important;\r\n  }\r\n  .mobileBody {\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftContent": `intro_leftContent__D2-4h`,
	"relativeContainer": `intro_relativeContainer__5WsLV`,
	"rightLines": `intro_rightLines__3xTSA`,
	"lineCont": `intro_lineCont__0HR4Y`,
	"green": `intro_green__AUCjL`,
	"purple": `intro_purple__-CuT7`,
	"leftLines": `intro_leftLines__FNDDm`,
	"body": `intro_body__CxNEZ`,
	"wrapper": `intro_wrapper__-ZGpL`,
	"watchVideo": `intro_watchVideo__i9eCv`,
	"actions": `intro_actions__bTngE`,
	"getStarted": `intro_getStarted__k+LVr`,
	"mobileBody": `intro_mobileBody__s-nIJ`
};
export default ___CSS_LOADER_EXPORT___;
